export function formatCurrency(value) {
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });

    return formatter.format(value);
}

export function getDomain() {
    return window.location.origin.startsWith("http://localhost")
        ? "https://localhost:44307"
        : window.location.origin;
}

/** True for /login and /login/... (avoids nested ?redirect= loops). */
export function isLoginPath(path) {
    if (!path || typeof path !== "string") return false;
    const pathname = path.split("?")[0];
    return pathname === "/login" || pathname.indexOf("/login/") === 0;
}

/**
 * Send the browser to /login?redirect=..., but never while already on login
 * (re-encoding the current URL would nest redirects until the URL explodes).
 */
export function redirectToLogin() {
    if (isLoginPath(window.location.pathname)) {
        return;
    }

    const currentPath = window.location.pathname + (window.location.search || "");
    window.location.href =
        "/login?redirect=" + encodeURIComponent(currentPath);
}

export function groupBy(list, key) {
    return list.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}

export function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

export function pluralize(resource, count) {
    if (count == 1) {
        return resource;
    }

    return resource + "s";
}

export function sum(list) {
    if (!list.length) return 0;

    const reducer = (accumulator, currentValue) => accumulator + currentValue;

    return list.reduce(reducer);
}

export function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return "";

    if (phoneNumber.length == 11) {
        phoneNumber = phoneNumber.substring(1);
    }

    const cleaned = ("" + phoneNumber).replace(/\D/g, "");
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (match) {
        return [
            cleaned.length == 10 ? "" : (match[1] || "") + " ",
            "(",
            match[2],
            ") ",
            match[3],
            "-",
            match[4],
        ].join("");
    }
    return null;
}

export function toTitleCase(value) {
    return value.replace(/\b./g, (txt) => txt.charAt(0).toUpperCase());
}

export function firstToLower(value) {
    return value.replace(/\b./g, (txt) => txt.charAt(0).toLowerCase());
}

export function except(source, ...keys) {
    keys = new Set(keys);

    return Object.keys(source).reduce((extracted, key) => {
        if (!keys.has(key)) {
            extracted[key] = source[key];
        }

        return extracted;
    }, {});
}

export function toISOLocal(d) {
    var z = (n) => ("0" + n).slice(-2);
    var zz = (n) => ("00" + n).slice(-3);
    var off = d.getTimezoneOffset();
    var sign = off < 0 ? "+" : "-";
    off = Math.abs(off);

    return (
        d.getFullYear() +
        "-" +
        z(d.getMonth() + 1) +
        "-" +
        z(d.getDate()) +
        "T" +
        z(d.getHours()) +
        ":" +
        z(d.getMinutes()) +
        ":" +
        z(d.getSeconds()) +
        "." +
        zz(d.getMilliseconds()) +
        sign +
        z((off / 60) | 0) +
        ":" +
        z(off % 60)
    );
}

export function truncate(string, maxLength = 50) {
    if (!string) return null;
    if (string.length <= maxLength) return string;
    return `${string.substring(0, maxLength)}...`;
}

export function skip(array, index) {
    return array.filter((x, i) => {
        if (i > index - 1) {
            return true;
        }
    });
}

export function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function pickPascalOrCamel(obj, pascalName, camelName) {
    if (!obj) return undefined;
    if (obj[pascalName] !== undefined && obj[pascalName] !== null) {
        return obj[pascalName];
    }
    return obj[camelName];
}

/** Twilio recording URLs need a media extension for browser <audio> elements. */
export function normalizeRecordingUrl(url) {
    if (!url) return null;
    const trimmed = url.toString().trim();
    if (!trimmed) return null;
    if (
        trimmed.indexOf("api.twilio.com") !== -1 &&
        !/\.(mp3|wav|ogg)(\?|$)/i.test(trimmed)
    ) {
        return trimmed + ".mp3";
    }
    return trimmed;
}

export default {
    getDomain,
    formatCurrency,
    groupBy,
    onlyUnique,
    pluralize,
    sum,
    formatPhoneNumber,
    toTitleCase,
    firstToLower,
    except,
    toISOLocal,
    truncate,
    skip,
    formatNumberWithCommas,
    normalizeRecordingUrl,
    pickPascalOrCamel,
};
